import { render, staticRenderFns } from "./edit-quiz-single-question.html?vue&type=template&id=48317010&scoped=true&"
import script from "./edit-quiz-single-question.vue?vue&type=script&lang=js&"
export * from "./edit-quiz-single-question.vue?vue&type=script&lang=js&"
import style0 from "./edit-quiz-single-question.css?vue&type=style&index=0&id=48317010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48317010",
  null
  
)

export default component.exports